/** Shared slug util — lowercase, collapse every non-alphanumeric run into
 *  `separator`, strip leading/trailing separators. Callers own their own
 *  empty-result fallback (e.g. AllocationSection's `target_<n>`,
 *  AddFormDialog's placeholder text). */
export function slugify(input: string, separator: '-' | '_' = '-'): string {
  return input
    .toLowerCase()
    .replace(/^[^a-z0-9]+|[^a-z0-9]+$/g, '')
    .replace(/[^a-z0-9]+/g, separator);
}
